module.exports = "/_next/static/images/icon-check-e09d393141de4730cc0dfc4065283536.svg";